import { getStringCharactersCount } from '@gem/utils';

import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const MAX_FIELD_LENGTH = 70;

export const userBioFieldValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (value && getStringCharactersCount(value) > MAX_FIELD_LENGTH) {
    return errorToText[ValidationErrorType.TooLong] || '';
  }

  return null;
};
